import axios from '@/axios'
import * as types from '../mutation-types'

export default {
	namespaced: true,
	state: {
		cardammanAmount: []
	},

	actions: {
		fetchAll({ commit }, { itemId, fromDate, toDate, page, perPage, ownerIds, usePagination }) {
			const params = { itemId, fromDate, toDate, page, perPage, usePagination };
			const urlSearchParams = new URLSearchParams();

			Object.keys(params).forEach(key => {
				if (params[key] !== null && params[key] !== undefined) urlSearchParams.append(key, params[key]);
			});

			if (Array.isArray(ownerIds)) {
				ownerIds.forEach(id => urlSearchParams.append('ownerIds', id));
			}
			urlSearchParams.append('sortByCreatedAt', true)
			urlSearchParams.append('nonDeleted', true)

			return axios.get('/itemTransaction', {
				params: urlSearchParams
			})
		},

		fetchCardammon({ commit }, { cardammomStatus, Withdetails }) {
			return axios.get('/itemTransaction/Inventory/cardammom', { params: { cardammomStatus, Withdetails } }).then((data) => {
				commit(types.STORE_CARDAMMON_INSORTING, data)
				return data
			})
		}
	},

	mutations: {
		[types.STORE_CARDAMMON_INSORTING](state, cardammanAmount) {
			state.cardammanAmount = cardammanAmount
		}
	}
}